<template>
    <div class="row">
        
            <div class="col-12 col-lg-6 mb-3">
                
            </div> 
            <div class="col-12 col-lg-6 mb-3 d-flex flex-row justify-content-end align-items-end">
                <button type="button" class="e-control e-btn e-lib e-success" data-ripple="true"  v-on:click="openFormNewRule">
                    Nueva norma
                </button>
            </div>
        
        <ejs-grid ref='grid' :dataSource='data2' :allowFiltering='true' :allowPaging="true" :allowSorting="true" :pageSettings='pageSettings' :toolbar='toolbar' :searchSettings='searchOptions' :toolbarClick='clickToolbarHandler'>
            <e-columns>
                <e-column field="prefijo" :headerText="$t('gridHeaderText.prefix')" :customAttributes="customAttributes" :prefix="prefix" :filterBarTemplate="filterPrefix"></e-column>
                <e-column field="articulo" :headerText="$t('gridHeaderText.article')" :customAttributes="customAttributes" :filterBarTemplate="filterArticle"></e-column>
                <e-column field="tipo" :headerText="$t('gridHeaderText.standard_type')" :customAttributes="customAttributes" :dataTypeRules="dataTypeRules" :filterBarTemplate="filterRule"></e-column>
                <e-column field="numero" :headerText="$t('gridHeaderText.number')" :customAttributes="customAttributes"  :filterBarTemplate="filterNumber"></e-column>
                <e-column field="anio" :headerText="$t('gridHeaderText.year')" :customAttributes="customAttributes" :filterBarTemplate="filterYear"></e-column>
                <e-column field="denominacion" :headerText="$t('gridHeaderText.denomination')"></e-column>
                <e-column field="razonSocial" :headerText="$t('gridHeaderText.tenant')" :customAttributes="customAttributes" :filterBarTemplate="filterTenant"></e-column>
                <e-column textAlign="center" :headerText="'OPCIONES'" :template="templateButtons" :id_cumplimiento="data.id"></e-column>
            </e-columns>
        </ejs-grid>
    </div>
</template>
<script>
import axios from 'axios';
import { Page, Sort, Toolbar, Search, GridPlugin, Filter } from "@syncfusion/ej2-vue-grids";
import { ComboBox, DropDownList } from '@syncfusion/ej2-dropdowns';
import { NumericTextBox, TextBox } from '@syncfusion/ej2-vue-inputs';

let prefix = null;
let prefixObj = null;

let rule = null;
let ruleObj = null;

let year = null;
let yearObj = null;

let number = null;
let numberObj = null;

let article = null;
let articleObj = null;

let tenant = null;
let tenantObj = null;

export default {
    name: 'add-rule-compliance',
    provide: {
        grid: [Sort, Page, Toolbar, Search, Filter]
    },
    props: ['data'], //id
    data() {
        return {
            dataTypeRules: {},
            data2: {},
            toolbar: [{ text: 'Limpiar', tooltipText: '', prefixIcon: 'e-clear', id: 'clear', align: 'Right', cssClass:'btn' }],
            pageSettings: { pageSize: 20 },
            searchOptions: {ignoreAccent: true},
            customAttributes: {class: 'textComplete'},
            prefix: ['Artículo','Sección','Cláusula', 'Título'],

            /*FILTROS */
            filterPrefix: { // Prefijo
                create: function (args) {
                    prefix = document.createElement('input');
                    prefix.id = 'prefix_id';
                    return prefix;
                },
                write: function(args){
                    prefixObj = new ComboBox({
                        dataSource: args.column.prefix,
                        change: function (args) {
                            Vue.prototype.$eventHub.$emit('onAdminRules');
                        }
                    });
                    prefixObj.appendTo(prefix);
                }
            }, 
            filterArticle: { // Articulo
                create: function (args) {
                    article = document.createElement('input');
                    article.id = 'article_id';
                    return article;
                },
                write: function(args){
                    articleObj = new TextBox({
                       change: function (args) {
                           Vue.prototype.$eventHub.$emit('onAdminRules');
                       } 
                    });
                    articleObj.appendTo(article);
                }
            },
            filterRule: { // Tipo de norma
                create: function (args) {
                    rule = document.createElement('input');
                    rule.id = 'rule_id';
                    return rule;
                },
                write: function(args){
                    ruleObj = new ComboBox({
                        dataSource: args.column.dataTypeRules,
                        fields: {text: 'tipo', value: 'valor'},
                        change: function (args) {
                            Vue.prototype.$eventHub.$emit('onAdminRules');
                        }
                    });
                    ruleObj.appendTo(rule);
                }
            }, 
            filterYear: { // Año
                create: function (args) {
                    year = document.createElement('input');
                    year.id = 'year_id';
                    return year;
                },
                write: function(args){
                    yearObj = new NumericTextBox({
                        format: '###',
                       change: function (args) {
                           Vue.prototype.$eventHub.$emit('onAdminRules');
                       } 
                    });
                    yearObj.appendTo(year);
                }
            }, 
            filterNumber: { // Número
                create: function (args) {
                    number = document.createElement('input');
                    number.id = 'number_id';
                    return number;
                },
                write: function(args){
                    numberObj = new TextBox({
                        format: '###',
                       change: function (args) {
                           Vue.prototype.$eventHub.$emit('onAdminRules');
                       } 
                    });
                    numberObj.appendTo(number);
                }
            }, 
            filterTenant: { // Tenant
                create: function (args) {
                    tenant = document.createElement('input');
                    tenant.id = 'tenant_id';
                    return tenant;
                },
                write: function(args){
                    tenantObj = new TextBox({
                       change: function (args) {
                           Vue.prototype.$eventHub.$emit('onAdminRules');
                       } 
                    });
                    tenantObj.appendTo(tenant);
                }
            },
            /* BOTONES */
            templateButtons: function (e) {
                return {
                    template: Vue.component('templateButtons', {
                        template: `<div class="text-center">
                                        <button type="button" :id="'buttonAsoc-' + data.index" v-on:click="onAddRuleCompliance(data)" class="btn btn-sm e-btn e-success" style="text-transform: none !important;">Asociar</button>
                                        <a v-on:click="onRuleEdit(data)" class="btn btn-sm btn-primary">Actualizar</a>
                                    </div>`,
                        data() {
                            return {
                                data: {}
                            };
                        },
                        methods: {
                            onAddRuleCompliance: function(data) {
                                axios.post('/auth/regulatoryAffairs/addRuleCompliance',{
                                    data: {norma_id: data.id, cumplimiento_id: data.column.id_cumplimiento}
                                }).then((response) => {
                                    Vue.prototype.$eventHub.$emit('onGetCompliance');
                                    Vue.prototype.$eventHub.$emit('showToastNotification', response.data);
                                    $("tbody > tr[aria-rowindex='"+data.index+"'] > td").css({"background":"#e0e0e0", "border-top":"#fff 1px solid"});
                                    $('#buttonAsoc-' + data.index).prop('disabled', true);
                                }).catch(error => {
                                        this.disabledButton = false;
                                });

                            },
                            onRuleEdit: function(data) {
                                Vue.prototype.$eventHub.$emit('toggleSidebarClick', 'Editar norma', 'edit-rule', data);
                            },
                        }
                    })
                }
            }
        }
    },
    methods: {
        getRules: function() {
            axios.post('/auth/rules/getRulesList2', {
                data: this.data.normas,
                prefix: $("#prefix_id").val(),
                type_rule: $("#rule_id_hidden").val(),
                number: $("#number_id").val(),
                year: $("#year_id").val(),
                article: $("#article_id").val(), 
                tenant: $("#tenant_id").val(), 
            }).then((response) => {
                this.data2 = response.data;
            });
        },
        getTypeRules: function() {
            axios.post('/auth/rules/getTypeRulesList').
            then((response) => {
                this.dataTypeRules = response.data;
            });
        },
        openFormNewRule: function() {
            Vue.prototype.$eventHub.$emit('toggleSidebarClick', 'Nueva Norma', 'add-rule', this.data);
        },
        clickToolbarHandler: function(args){
            if (args.item.id === 'clear') {
                this.$refs.grid.ej2Instances.searchSettings.key = "";
                this.$refs.grid.ej2Instances.clearFiltering(); 
                this.$refs.grid.ej2Instances.refreshHeader();
                this.getRules();
            }
        },
    },
    created() {
        this.getTypeRules();
        this.getRules();
        this.$eventHub.$on('onAdminRules', this.getRules);
    }
}
</script>